import { render } from "./relationUserInfo.vue?vue&type=template&id=730c462b&scoped=true"
import script from "./relationUserInfo.vue?vue&type=script&lang=js"
export * from "./relationUserInfo.vue?vue&type=script&lang=js"

import "./relationUserInfo.vue?vue&type=style&index=0&id=730c462b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-730c462b"]])

export default __exports__